import { render, staticRenderFns } from "./InventManage.vue?vue&type=template&id=c457cce2&scoped=true&"
import script from "./InventManage.vue?vue&type=script&lang=js&"
export * from "./InventManage.vue?vue&type=script&lang=js&"
import style0 from "./InventManage.vue?vue&type=style&index=0&id=c457cce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c457cce2",
  null
  
)

export default component.exports